import Mosaic from './Mosaic';
import SkeletonMosaic from './Mosaic.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <SkeletonMosaic {...props} /> : <Mosaic {...props} />;
}
export { MoreItemsButton } from './Mosaic';
